import React from 'react';

import BadgeBase, { TBadge } from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

const Brand = (props: Omit<TBadge, 'signal'>) => <BadgeBase {...props} signal={BadgeSignals.Brand} />;

export default Brand;
